import React from "react";

function BusinessSummary() {
  return (
    <section className="p-12 text-center">
      <h1 className="-mt-8 mb-8">Business Summary</h1>

      <div class="stats stats-vertical md:stats-horizontal shadow w-full">
        <div class="stat gap-4 py-8">
          <div class="stat-figure text-secondary">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              class="inline-block w-8 h-8 stroke-current"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
          </div>

          <div class="stat-title text-xl">Total Revenue</div>
          <div class="stat-value text-4xl text-primary">77M</div>
          <div class="stat-desc text-sm">Jan 1st - Dec 31st</div>
        </div>

        <div class="stat gap-4 py-8">
          <div class="stat-figure text-secondary">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              class="inline-block w-8 h-8 stroke-current"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
              ></path>
            </svg>
          </div>

          <div class="stat-title text-xl">Global Factories</div>
          <div class="stat-value text-4xl text-accent">1,780</div>
          <div class="stat-desc text-sm">↗︎ 400 (28.99%)</div>
        </div>

        <div class="stat gap-4 py-8">
          <div class="stat-figure text-secondary">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              class="inline-block w-8 h-8 stroke-current"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
              ></path>
            </svg>
          </div>

          <div class="stat-title text-xl">Customer Base</div>
          <div class="stat-value text-4xl text-[#00193d]">4,550</div>
          <div class="stat-desc text-sm">↗︎ 1200 (35.82%)</div>
        </div>
      </div>
    </section>
  );
}

export default BusinessSummary;
